import Layout from 'components/common/Layout'
import { useState } from 'react'
import Header from '../Header'
import ActionBar from './ActionBar'
import VideoPopUp from '../VideoPopUp'
import { ProfileTypes, projectSectionFeature } from 'constants/'
import Projects from 'components/Course/Projects'
import { Container, Spacing, Expander, TypographyElement, Icon, Icons } from 'UI'
import CoursesList from '../CoursesList'
import LearningPathInfos from '../LearningPathInfos'
import Text from './text.json'
import BoostCareer from '../BoostCareer'
import EnterpriseOffer from '../EnterpriseOffer'
import { createUseStyles } from 'react-jss'
import style from './style'
import VideoThumbnail from '../Header/VideoThumbnail'
import Tags from '../Tags'
import Categories from '../Categories'

const useStyle = createUseStyles(style)

export default ({
  loading,
  ProfileType,
  Description,
  Objectives,
  PreRequirements,
  PublicConcerned,
  learningPathId,
  learningPathProjects,
  PresentationVideoThumbnail
}) => {
  const [showPopUp, setShowPopUp] = useState(false)
  const { offersContainer, info, icon } = useStyle()
  const isProfileTypeValid = ProfileType === ProfileTypes.Default || ProfileType === ProfileTypes.Buyer || ProfileType === ProfileTypes.FreeSubscriber
  return (
    <>
      <Layout>
        <Container>
          {!loading && PresentationVideoThumbnail ? (<VideoThumbnail onVideoThumbnailClick={() => setShowPopUp(true)} />) : null}
        </Container>
        <Header onVideoThumbnailClick={() => setShowPopUp(true)} />
        <Container>
          {projectSectionFeature
            ? <Projects
                learningPathId={learningPathId}
                learningPathProjects={learningPathProjects}
                ProfileType={ProfileType}
                paper
                padding={Spacing(5)}
                margin={Spacing(6, 0, 10, 0)}
                isMobile
                isLearningPath
              />
            : null}
        </Container>
        <Container>
          <CoursesList />
        </Container>
        <Container>
          <LearningPathInfos margin={Spacing(6, 0, 0)} loading={loading} />
          <Categories />
          <Tags />
          <TypographyElement
            variant='heading2'
            Component='h2'
            spacing='64px 0 24px 0'
          >
            {Text.descriptionAndObjectives}
          </TypographyElement>
          <Expander
            marginBottom={16}
            title={Text.description}
          >
            <TypographyElement
              variant='body1'
              dangerouslySetText={Description}
            />
          </Expander>
          <Expander
            marginBottom={16}
            title={Text.objectives}
          >
            {
              Objectives?.map((item, key) => (
                <TypographyElement
                  key={key}
                  variant='body1'
                  align='left'
                  display='flex'
                  className={info}
                  margin='8px 0 0 0'
                >
                  <Icon iconName={Icons.check} style={icon} />
                  {item}
                </TypographyElement>
              ))
            }
          </Expander>
          <Expander
            marginBottom={16}
            title={Text.PreRequirements}
          >
            {
              PreRequirements?.map((item, key) => (
                <TypographyElement
                  key={key}
                  variant='body1'
                  align='left'
                  display='flex'
                  className={info}
                  margin='8px 0 0 0'
                >
                  <Icon iconName={Icons.check} style={icon} />
                  {item}
                </TypographyElement>
              ))
            }
          </Expander>
          <Expander
            marginBottom={16}
            title={Text.concernedAudiences}
          >
            {
              PublicConcerned?.map((item, key) => (
                <TypographyElement
                  key={key}
                  variant='body1'
                  align='left'
                  display='flex'
                  className={info}
                  margin='8px 0 0 0'
                >
                  <Icon iconName={Icons.check} style={icon} />
                  {item}
                </TypographyElement>
              ))
            }
          </Expander>
          <div className={offersContainer}>
            <BoostCareer margin={Spacing(0, 0, 6, 0)} />
            <EnterpriseOffer loading={loading} noMargin />
          </div>
        </Container>
      </Layout>
      {!ProfileType || isProfileTypeValid ? <ActionBar /> : null}
      <VideoPopUp showPopUp={showPopUp} setShowPopUp={setShowPopUp} />
    </>
  )
}
